import AddNew from "./AddNew";
import List from "./List";

export default function Passengers() {
    return (
        <>
            <AddNew/>
            <List/>
        </>
    )
}
